import { C as CosmosIconSearch$1, d as defineCustomElement$1 } from './p-COoxk1Ir.js';

const CosmosIconSearch = CosmosIconSearch$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSearch, defineCustomElement };
